module.exports = __webpack_public_path__ + "static/based-segmentation-5-e717a0bcddec3b54698c818e7cc00a91.png";